// extracted by mini-css-extract-plugin
export default {"container":"BookDemoPage_container__WkUdL","title":"BookDemoPage_title__51i3M"};